import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import CustomTooltip from "../customTooltip";
import "./BarChartColuna.scss";

// biblioteca https://ui.shadcn.com/charts

export function BarChartColuna(props) {
  const [data, setData] = useState();

  useEffect(() => {
    const container = document.querySelector(".barchart");
    const style = getComputedStyle(container);

    const novaArray = props.chartData.map((item, index) => {
      const varIndex = (index % 5) + 1; // 1 a 5
      const cor = `hsl(${style
        .getPropertyValue(`--chart-${varIndex}`)
        .trim()})`;

      return {
        ...item,
        fill: item.fill || cor,
      };
    });
    setData(novaArray);
  }, [props.chartData]);

  return (
    <>
      {props.title !== null && <p className="titleBarchart">{props.title}</p>}
      <div className="barchart" style={{ width: "100%", height: props.height }}>
        <ResponsiveContainer>
          <BarChart
            data={data}
            //Margin para as labels que ficam em cima.
            margin={{ top: 20, right: 0, left: 0, bottom: 0 }}
          >
            <CartesianGrid vertical={false} horizontal={false} />
            <XAxis
              className={`${props.cursorpoint ? "cursorp" : ""}`}
              dataKey={props.dataKey}
              tickLine={false}
              axisLine={false}
              tickMargin={10}
              tick={{ fill: "var(--color-018-01)", fontSize: 12 }}
              onClick={(data, index) => {
                props.functionClick(data);
              }}
            />
            <Tooltip
              content={<CustomTooltip />}
              cursor={false} //Remove o fundo branco.
            />
            <Bar
              className={`barras ${props.cursorpoint ? "cursorp" : ""}`}
              dataKey={props.BarDataKey}
              label={{
                position: props.BarPositionLabel,
                fill: "var(--color-018-01)",
                fontSize: props.BarFontSize,
              }}
              fill={({ payload }) => payload.fill}
              radius={8}
              onClick={(data, index) => {
                props.functionClick(data);
              }}
            />
            {props.legenda && (
              <Legend
                layout={props.legendaLayout}
                align={props.legendaAlign}
                verticalAlign={props.legendaVerticalAlign}
                iconType={props.legendaIconType}
              />
            )}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </>
  );
}
BarChartColuna.defaultProps = {
  //BarChart
  chartData: [
    { browser: "Chrome", visitors: 375, fill: "" },
    { browser: "Safari", visitors: 200, fill: "" },
    { browser: "Firefox", visitors: 187, fill: "" },
    { browser: "Edge", visitors: 173, fill: "" },
    { browser: "Other", visitors: 90, fill: "" },
  ],
  height: 250,
  //XAxis
  dataKey: "browser",
  //Bar
  BarDataKey: "visitors",
  BarPositionLabel: "top",
  BarFontSize: 16,
  lstLabel: [],
  functionClick: () => null,
  cursorpoint: true,
  title: null,
  //Legendas
  legenda: false,
  legendaLayout: "vertical",
  legendaAlign: "left",
  legendaVerticalAlign: "bottom",
  legendaIconType: "circle",
};
